import api from './api';

export const searchService = {
  globalSearch: (query, limit = 10) => api.get('/search/', { params: { query, limit } })
};
